// This file was automatically generated from render.chartFeedItem.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.chartFeedItem');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appchart.letters.unreadAlertNotification');
goog.require('el8.template.appshared.docTags');
goog.require('el8.template.button');
goog.require('el8.template.core');
goog.require('el8.template.ptdata.addendums');
goog.require('el8.template.ptdata.letterReceipts');
goog.require('el8.template.ptdata.letters');
goog.require('el8.template.ptdata.model.attachment');
goog.require('el8.template.ptdata.model.dcMedOrder');
goog.require('el8.template.ptdata.model.denialMedOrder');
goog.require('el8.template.ptdata.model.medOrder');
goog.require('el8.template.ptdata.model.message');
goog.require('el8.template.ptdata.model.note');
goog.require('el8.template.ptdata.model.order');
goog.require('el8.template.ptdata.model.order.referral');
goog.require('el8.template.ptdata.reports');
goog.require('el8.template.render.chartFeedItem.visitNoteContent');
goog.require('el8.template.render.chartFeedItem.visitNoteTemplate.oneCol');
goog.require('el8.template.render.chartFeedItem.visitNoteTemplate.twoCol');
goog.require('el8.template.render.messageThreadContent');
goog.require('el8.template.render.signOff');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.reportItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight report-item"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  el8.template.ptdata.reports.chartFeedIcon(opt_data.report, output);
  output.append('</div><div class="el8FeedItemContainer"><span class="el8FeedItemDocumentDate">Document Dated: ', (soy.$$escapeHtml(opt_data.report.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.report.documentDate)) : ''), '</span><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader"><a class="details-trigger " _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.ptdata.reports.feedSummary(opt_data.report, output);
  output.append('</a></p>');
  el8.template.ptdata.reports.noteListSummary(opt_data.report, output);
  if (opt_data.referringThreads.length > 0) {
    output.append('<p>');
    var threadList22698 = opt_data.referringThreads;
    var threadListLen22698 = threadList22698.length;
    for (var threadIndex22698 = 0; threadIndex22698 < threadListLen22698; threadIndex22698++) {
      var threadData22698 = threadList22698[threadIndex22698];
      el8.template.ptdata.model.message.referencedFeedSummary(threadData22698, output);
    }
    output.append('</p>');
  }
  if (opt_data.indexItem.snippets && opt_data.indexItem.snippets.length || opt_data.labResults && opt_data.labResults.length) {
    output.append('<div class="el8ShortLabelPadding"><div class="snippetHighlight el8StandardFontSize">');
    if (opt_data.indexItem.snippets && opt_data.indexItem.snippets.length) {
      var snippetList22707 = opt_data.indexItem.snippets;
      var snippetListLen22707 = snippetList22707.length;
      for (var snippetIndex22707 = 0; snippetIndex22707 < snippetListLen22707; snippetIndex22707++) {
        var snippetData22707 = snippetList22707[snippetIndex22707];
        output.append('<div class="el8FieldSection"><pre>...', soy.$$escapeHtml(snippetData22707), '...</pre></div>');
      }
    }
    if (opt_data.labResults && opt_data.labResults.length) {
      var labResultList22714 = opt_data.labResults;
      var labResultListLen22714 = labResultList22714.length;
      for (var labResultIndex22714 = 0; labResultIndex22714 < labResultListLen22714; labResultIndex22714++) {
        var labResultData22714 = labResultList22714[labResultIndex22714];
        output.append('<div class="el8FieldSection">', soy.$$escapeHtml(labResultData22714.labTest), ' - ', soy.$$escapeHtml(labResultData22714.value), ' ', soy.$$escapeHtml(labResultData22714.units), (opt_data.labResults.documentingPersonnelType) ? (opt_data.labResults.documentingPersonnelType == 'Physician') ? '<div class="el8PhysicianInputIconSmall elSnippetIconSmallPosition"></div>' : '<div class="el8StaffInputIconSmall elSnippetIconSmallPosition"></div>' : '', '</div>');
      }
    }
    output.append('</div></div>');
  }
  if (opt_data.report.signDate) {
    el8.template.render.signOff.summary(opt_data.report, output);
  }
  el8.template.appshared.docTags.content({docTags: opt_data.report.docTags, feedItemId: opt_data.feedItemId}, output);
  output.append('<ul class="el8ButtonContainer padt5">', (el8Globals.FEATURES.Letters) ? '<li class="mr10"><a class="el8FeedItemActionLink attach-to-provider" data-id="' + soy.$$escapeHtml(opt_data.report.id) + '">Send to Provider</a></li>' + ((el8Globals.FEATURES.PatientPortal) ? '<li class="mr10"><a class="el8FeedItemActionLink attach-to-passport" data-id="' + soy.$$escapeHtml(opt_data.report.id) + '">Send to Patient</a></li>' : '') : '', '<li class=""><a class="el8FeedItemActionLink write-message-trigger" data-id="', soy.$$escapeHtml(opt_data.report.id), '">Office Message</a></li></ul></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.addendumItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconReport"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.ptdata.addendums.feedSummary({item: opt_data.item, referencedDoc: opt_data.referencedDoc}, output);
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.orderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append((opt_data.order.modelClass == 'ReferralOrder') ? '<div class="el8FeedItemIconReferral"></div>' : '<div class="el8FeedItemIconOrder"></div>', '</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>');
  if (opt_data.order.modelClass == 'ReferralOrder') {
    output.append('<p class="el8FeedItemHeader"><span class="el8TagItem mr5">Referral</span> <a class="details-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
    el8.template.ptdata.model.order.referral.feedSummary({order: opt_data.order}, output);
    output.append('</a></p>');
  } else {
    output.append('<p class="el8FeedItemHeader"><span class="el8TagItem mr5">Order</span><a class="details-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
    el8.template.ptdata.model.order.orderFeedSummary({order: opt_data.order}, output);
    output.append('</a></p>');
  }
  output.append('<ul class="el8ButtonContainer padt5"><li class="mr10"><a class="el8FeedItemActionLink re-order-trigger" data-id="', soy.$$escapeHtml(opt_data.order.id), '">Re-Order</a></li>', (el8Globals.FEATURES.Letters) ? '<li class="mr10"><a class="el8FeedItemActionLink attach-to-provider" data-id="' + soy.$$escapeHtml(opt_data.order.id) + '">Send to Provider</a></li>' + ((el8Globals.FEATURES.PatientPortal) ? '<li class="mr10"><a class="el8FeedItemActionLink attach-to-passport" data-id="' + soy.$$escapeHtml(opt_data.order.id) + '">Send to Patient</a></li>' : '') : '', '<li class=""><a class="el8FeedItemActionLink write-message-trigger" data-id="', soy.$$escapeHtml(opt_data.order.id), '">Office Message</a></li></ul></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.medOrderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  el8.template.ptdata.model.medOrder.chartFeedIcon(opt_data.order, output);
  output.append('</div><div class="el8FeedItemContainer"><span class="el8FeedItemDocumentDate">Started on: ', (soy.$$escapeHtml(opt_data.order.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.startDate)) : ''), '</span><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>');
  if (opt_data.indexItem && opt_data.indexItem.snippets) {
    output.append('<div style="border: 1px solid yellow;">');
    var snippetList22833 = opt_data.indexItem.snippets;
    var snippetListLen22833 = snippetList22833.length;
    for (var snippetIndex22833 = 0; snippetIndex22833 < snippetListLen22833; snippetIndex22833++) {
      var snippetData22833 = snippetList22833[snippetIndex22833];
      output.append('<pre>...', soy.$$escapeHtml(snippetData22833), '...</pre><br/><br/>');
    }
    output.append('</div>');
  }
  el8.template.ptdata.model.medOrder.feedSummary(soy.$$augmentData(opt_data.order, {highlight: true, hasActions: opt_data.hasActions}), output);
  output.append((opt_data.order.isThreadActive) ? '<ul class="el8ButtonContainer padt5"><li class="el8LgSpaceButtonItem"><a class="el8FeedItemActionLink rx-refill-trigger" data-id="' + soy.$$escapeHtml(opt_data.order.id) + '">Rx: Refill</a></li><li class="el8LgSpaceButtonItem"><a class="el8FeedItemActionLink rx-dose-trigger" data-id="' + soy.$$escapeHtml(opt_data.order.id) + '">Rx: Change Dose</a></li><li class="el8LgSpaceButtonItem"><a class="el8FeedItemActionLink write-message-trigger" data-id="' + soy.$$escapeHtml(opt_data.order.id) + '">Office Message</a></li></ul>' : '<ul class="el8ButtonContainer padt5"><li class="el8LgSpaceButtonItem"><a class="el8FeedItemActionLink rx-reorder-trigger" data-id="' + soy.$$escapeHtml(opt_data.order.id) + '">Rx: Re-Order</a></li><li class="el8LgSpaceButtonItem"><a class="el8FeedItemActionLink rx-doc-change-trigger" data-id="' + soy.$$escapeHtml(opt_data.order.id) + '">Document Change</a></li><li class="el8LgSpaceButtonItem"><a class="el8FeedItemActionLink write-message-trigger" data-id="' + soy.$$escapeHtml(opt_data.order.id) + '">Office Message</a></li></ul>', '</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.dcMedOrderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  el8.template.ptdata.model.dcMedOrder.chartFeedIcon(opt_data.order, output);
  output.append('</div><div class="el8FeedItemContainer"><span class="el8FeedItemDocumentDate">Discontinued on: ', (soy.$$escapeHtml(opt_data.order.discontinueDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.discontinueDate)) : ''), '</span><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>');
  if (opt_data.indexItem && opt_data.indexItem.snippets) {
    output.append('<div style="border: 1px solid yellow;">');
    var snippetList22878 = opt_data.indexItem.snippets;
    var snippetListLen22878 = snippetList22878.length;
    for (var snippetIndex22878 = 0; snippetIndex22878 < snippetListLen22878; snippetIndex22878++) {
      var snippetData22878 = snippetList22878[snippetIndex22878];
      output.append('<pre>...', soy.$$escapeHtml(snippetData22878), '...</pre><br/><br/>');
    }
    output.append('</div>');
  }
  el8.template.ptdata.model.dcMedOrder.feedSummary(soy.$$augmentData(opt_data.order, {highlight: true, hasActions: opt_data.hasActions}), output);
  output.append('<ul class="el8ButtonContainer padt5"><li class="el8LgSpaceButtonItem"><a class="el8FeedItemActionLink rx-reorder-trigger" data-id="', soy.$$escapeHtml(opt_data.order.id), '">Rx: Re-Order</a></li><li class="el8LgSpaceButtonItem"><a class="el8FeedItemActionLink write-message-trigger" data-id="', soy.$$escapeHtml(opt_data.order.id), '">Office Message</a></li></ul></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.nonvisitNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover el8NonvisitNoteItem am-highlight nonvisit-note-item" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  el8.template.ptdata.model.note.chartFeedIcon(opt_data, output);
  output.append('</div><div class="nonvisit-note-container el8FeedItemContainer"><div class="el8NonvisitNoteContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8333"><span class="el8Bold">');
  el8.template.ptdata.model.note.nonvisitNoteDescription(opt_data, output);
  output.append('</span> ', (soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.feedDate)) : ''), ' ', (soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.feedDate)) : ''), '</p>');
  if (opt_data.images.length > 0) {
    output.append('<ul>');
    var imageList22917 = opt_data.images;
    var imageListLen22917 = imageList22917.length;
    for (var imageIndex22917 = 0; imageIndex22917 < imageListLen22917; imageIndex22917++) {
      var imageData22917 = imageList22917[imageIndex22917];
      output.append('<li class="images_', soy.$$escapeHtml(imageIndex22917), ' docImage"><div data-src="', soy.$$escapeHtml(imageData22917), '" class="image-item imageLoading" data-id="', soy.$$escapeHtml(opt_data.id), '"></div></li>');
    }
    output.append('</ul>');
  }
  if (opt_data.bullets.length == 1) {
    output.append('<p class="el8Preserve">', (opt_data.bullets[0].text) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.bullets[0].text)) : soy.$$escapeHtml(opt_data.bullets[0].text)) : (opt_data.bullets[0].safeText) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(opt_data.bullets[0].safeText) : opt_data.bullets[0].safeText) : '', '</p>');
  } else {
    output.append('<ol>');
    var bList22941 = opt_data.bullets;
    var bListLen22941 = bList22941.length;
    for (var bIndex22941 = 0; bIndex22941 < bListLen22941; bIndex22941++) {
      var bData22941 = bList22941[bIndex22941];
      el8.template.core.listItem(bData22941, output);
    }
    output.append('</ol>');
  }
  if (opt_data.ownedDocs.length) {
    output.append('<div class="spacer5"><p class="el8AppColor">Orders:</p><ol>');
    var itemList22948 = opt_data.ownedDocs;
    var itemListLen22948 = itemList22948.length;
    for (var itemIndex22948 = 0; itemIndex22948 < itemListLen22948; itemIndex22948++) {
      var itemData22948 = itemList22948[itemIndex22948];
      el8.template.core.listItem(itemData22948, output);
    }
    output.append('</ol></div>');
  }
  if (opt_data.referencedDocs.length) {
    output.append('<div class="spacer5"><p class="el8AppColor">Documents Referenced:</p><ol>');
    var itemList22955 = opt_data.referencedDocs;
    var itemListLen22955 = itemList22955.length;
    for (var itemIndex22955 = 0; itemIndex22955 < itemListLen22955; itemIndex22955++) {
      var itemData22955 = itemList22955[itemIndex22955];
      el8.template.core.listItem(itemData22955, output);
    }
    output.append('</ol></div>');
  }
  if (opt_data.vitalsCollections.length) {
    output.append('<div class="spacer5"><p class="el8AppColor">Vitals:</p><ol>');
    var itemList22962 = opt_data.vitalsCollections;
    var itemListLen22962 = itemList22962.length;
    for (var itemIndex22962 = 0; itemIndex22962 < itemListLen22962; itemIndex22962++) {
      var itemData22962 = itemList22962[itemIndex22962];
      el8.template.core.listItem(itemData22962, output);
    }
    output.append('</ol></div>');
  }
  if (opt_data.attachments.length) {
    output.append('<div class="spacer5"><p class="el8AppColor">Original File:</p><ol>');
    var itemList22969 = opt_data.attachments;
    var itemListLen22969 = itemList22969.length;
    for (var itemIndex22969 = 0; itemIndex22969 < itemListLen22969; itemIndex22969++) {
      var itemData22969 = itemList22969[itemIndex22969];
      output.append('<li class="el8BulletText"><a target="_blank" rel="noopener" href="', soy.$$escapeHtml(itemData22969.downloadUrl), '" tabindex="-1">');
      el8.template.ptdata.model.attachment.summary(itemData22969, output);
      output.append('</a></li>');
    }
    output.append('</ol></div>');
  }
  el8.template.appshared.docTags.content({docTags: opt_data.docTags, feedItemId: opt_data.feedItemId}, output);
  el8.template.render.signOff.summary(opt_data, output);
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.messageThread = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconMessage"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>');
  el8.template.render.messageThreadContent.content(opt_data, output);
  el8.template.render.signOff.summary(soy.$$augmentData(opt_data, {signUserName: opt_data.signOffUser}), output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem visit-note-item" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><div class="visitNoteItem overlayFeedItem el8FeedItemHover ', (opt_data.isAmendPreview || ! opt_data.signDate) ? ' containerNew' : '', '"><div class="headerContainer"><div class="description"><span class="statusText el8Elt"></span><span class="eltlr5">', soy.$$escapeHtml(opt_data.formattedFeedDate), '</span>', (! opt_data.signDate) ? '<span class="elt">* PREVIEW *</span>' : '', '<span class="item-description-text emphasis elt">- ', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.description)) : soy.$$escapeHtml(opt_data.description)), '  -</span>', (opt_data.edits.length) ? '<span class="el8AttentionText elt">(Amended on ' + ((opt_data.edits[opt_data.edits.length - 1].signDate) ? (soy.$$escapeHtml(opt_data.edits[opt_data.edits.length - 1].signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.edits[opt_data.edits.length - 1].signDate)) : '') : (soy.$$escapeHtml(opt_data.edits[opt_data.edits.length - 1].createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.edits[opt_data.edits.length - 1].createDate)) : '')) + ') </span>' : '', (opt_data.headerSummary) ? '<span class="el8AppText"> ' + soy.$$escapeHtml(opt_data.headerSummary) + '</span>' : '', '</div><span class="threePaneButton toggle-summary-trigger">View Complete Note</span></div><div class="noteFormContent"><div class="cardDetails">');
  el8.template.render.chartFeedItem.visitNoteContent.sectionReason({reason: opt_data.reason, age: opt_data.age}, output);
  el8.template.render.chartFeedItem.visitNoteContent.sectionPreOp({dateprocedure: opt_data.dateprocedure, consultant: opt_data.consultant, attending: opt_data.attending}, output);
  if (opt_data.templateClass == 'oneCol') {
    el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.content(opt_data, output);
  } else {
    el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.content(opt_data, output);
  }
  if (opt_data.images.length || opt_data.attachments.length) {
    output.append('<h4 class="el8SectionHeaderNoCollapse">Attachments</h4>');
    el8.template.render.chartFeedItem.visitNoteContent.sectionImages({images: opt_data.images}, output);
    if (opt_data.attachments.length) {
      output.append('<div class="cardColumnTB"><fieldset class="noBorderForm"><div class="spacer5"><p class="el8AppColor">Original File:</p><ol>');
      var itemList23053 = opt_data.attachments;
      var itemListLen23053 = itemList23053.length;
      for (var itemIndex23053 = 0; itemIndex23053 < itemListLen23053; itemIndex23053++) {
        var itemData23053 = itemList23053[itemIndex23053];
        output.append('<li class="el8BulletText"><a class="rightIndent" target="_blank" rel="noopener" href="', soy.$$escapeHtml(itemData23053.downloadUrl), '" tabindex="-1">');
        el8.template.ptdata.model.attachment.summary(itemData23053, output);
        output.append('</a></li>');
      }
      output.append('</ol></div></fieldset></div>');
    }
  }
  el8.template.appshared.docTags.content({docTags: opt_data.docTags, feedItemId: opt_data.feedItemId}, output);
  output.append('<div class="cardColumn">');
  if (opt_data.signDate) {
    el8.template.render.signOff.summary(opt_data, output);
  }
  if (opt_data.edits) {
    var eList23070 = opt_data.edits;
    var eListLen23070 = eList23070.length;
    for (var eIndex23070 = 0; eIndex23070 < eListLen23070; eIndex23070++) {
      var eData23070 = eList23070[eIndex23070];
      output.append('<p class="el8SignoffText">', (eData23070.signDate) ? 'Amended and signed by ' + soy.$$escapeHtml(eData23070.signUserName) + ' on ' + (soy.$$escapeHtml(eData23070.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(eData23070.signDate)) : '') + ' <a class="edit-changes-trigger" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '" _id="' + soy.$$escapeHtml(eData23070.id) + '">(see changes)</a>' : 'In-progress amendment created by ' + soy.$$escapeHtml(eData23070.createUserName) + ' on ' + (soy.$$escapeHtml(eData23070.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(eData23070.createDate)) : ''), '</p>');
    }
  }
  output.append('</div>');
  el8.template.render.chartFeedItem.visitNoteContent.sectionBilling(soy.$$augmentData(opt_data.bill, {timeWithPatient: opt_data.timeWithPatient, timeDocumenting: opt_data.timeDocumenting, checkout: opt_data.checkout, muInfo: opt_data.muInfo, amendmentRequest: opt_data.amendmentRequest, showMuInfo: opt_data.showMuInfo}), output);
  output.append('</div></div>');
  el8.template.button.buttons({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.denialMedOrder = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconRx"></div></div><div class="el8FeedItemContainer" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader">Denied Refill Request for ', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.item.medication)) : soy.$$escapeHtml(opt_data.item.medication)), (opt_data.item.refills) ? ' #' + soy.$$escapeHtml(opt_data.item.refills) : '', (opt_data.item.note || opt_data.item.reason) ? ' because ' + soy.$$escapeHtml(opt_data.item.note) + ((opt_data.item.reason) ? ' [' + soy.$$escapeHtml(opt_data.item.reason) + ']' : '') : '', '</p>');
  if (opt_data.item.state == 'error' || opt_data.item.state == 'failure') {
    output.append('<p class="el8AttentionText">Denial not received');
    el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data.item, {preposition: 'by'}), output);
    output.append((opt_data.item.denialReason == 'E') ? '.  Refill request was dismissed because response cannot be sent electronically.</p>' : ' due to error.</p>');
  } else if (opt_data.item.state == 'new' || opt_data.item.state == 'sending' || opt_data.item.state == 'sent') {
    output.append('<p class="el8AppText">Being sent');
    el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data.item, {preposition: 'to'}), output);
    output.append('...</p>');
  } else if (opt_data.item.state == 'pending_complete') {
    output.append('<p class="el8AppText">Sent');
    el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data.item, {preposition: 'to'}), output);
    output.append(' successfully.</p>');
  } else if (opt_data.item.state == 'complete') {
    output.append('<p class="el8AppText">Sent');
    el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data.item, {preposition: 'to'}), output);
    output.append(' successfully.<a class="explain-surescripts-trigger">*</a></p>');
  }
  el8.template.ptdata.model.denialMedOrder.signature(opt_data.item, output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.rxHistoryDownload = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconDocMed"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader"><a class="view-fills-trigger" data-id="', soy.$$escapeHtml(opt_data.summaryItem.id), '">', soy.$$escapeHtml(opt_data.summaryItem.description), '</a></p>', (opt_data.summaryItem.eligPbmName) ? '<p class="el8GrayText">Source: ' + soy.$$escapeHtml(opt_data.summaryItem.eligPbmName) + '</p>' : '');
  el8.template.render.signOff.summary(opt_data.summaryItem, output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.letterItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover el8LetterItem am-highlight letter-item" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '" data-id="', soy.$$escapeHtml(opt_data.letter.id), '"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('</div><div class="el8FeedItemContainer"><div class="el8LetterContainer"><div class="el8FeedItemActionContainer feed-button-list">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedIconContainer">');
  el8.template.ptdata.letters.feedIcon(opt_data.letter, output);
  el8.template.ptdata.letters.letterMetadataCounts(opt_data.letter, output);
  output.append('</div>');
  el8.template.ptdata.letters.signedSummary(opt_data, output);
  output.append('</div>');
  el8.template.ptdata.letters.secondarySection(opt_data, output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.unreadLetterNotificationItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  el8.template.appchart.letters.unreadAlertNotification.feedIcon({isSendToPatient: opt_data.letter.isSendToPatient, isReferralLetter: opt_data.letter.isReferralLetter}, output);
  output.append('</div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader el8Ellipsis">Not opened by recipient -- ');
  el8.template.appchart.letters.unreadAlertNotification.feedSummary(soy.$$augmentData(opt_data, {linkToDetail: true}), output);
  output.append('</p>');
  el8.template.appchart.letters.unreadAlertNotification.chartFeedItem(opt_data, output);
  el8.template.appchart.letters.unreadAlertNotification.signOffSummary(soy.$$augmentData(opt_data.unreadLetterNotification, {unreadLetterNotification: opt_data.unreadLetterNotification}), output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.letterReceipt = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover el8LetterItem am-highlight letter-receipt-item" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '" data-id="', soy.$$escapeHtml(opt_data.letterReceipt.id), '"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('</div><div class="el8FeedItemContainer"><div class="el8LetterContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedIconContainer">');
  el8.template.ptdata.letterReceipts.feedIcon(opt_data.letterReceipt, output);
  el8.template.ptdata.letterReceipts.metadataCounts(opt_data.letterReceipt, output);
  output.append('</div>');
  el8.template.ptdata.letterReceipts.summary(opt_data.letterReceipt, output);
  output.append('</div>');
  el8.template.ptdata.letterReceipts.secondarySection(opt_data.letterReceipt, output);
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.xmlSummaryItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconReport"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader"><a class="view-xml-summary" data-id="', soy.$$escapeHtml(opt_data.summaryItem.id), '">Patient Summary (', (opt_data.summaryItem.authorName) ? soy.$$escapeHtml(opt_data.summaryItem.authorName) : 'Unknown Author', ')</a></p>');
  if (opt_data.summaryItem.signDate) {
    el8.template.render.signOff.summary(opt_data.summaryItem, output);
  }
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.hl7MessageItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItem el8FeedItemHover am-highlight"><div class="el8FeedItemDate el8BreakWord">');
  el8.template.render.chartFeedItem.feedDate({feedDate: opt_data.feedDate}, output);
  output.append('<div class="el8FeedItemIconReport"></div></div><div class="el8FeedItemContainer"><div class="el8FeedItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttonsInfo, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><p class="el8FeedItemHeader"><a class="view-hl7-message" data-id="', soy.$$escapeHtml(opt_data.messageItem.id), '">Patient Immunization Summary</a></p>');
  if (opt_data.messageItem.signDate) {
    el8.template.render.signOff.summary(opt_data.messageItem, output);
  }
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.feedDate = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.feedDate)) : ''));
  if (!opt_sb) return output.toString();
};
